import { Box, Flex, Link, VStack } from '@chakra-ui/react';
import { StepTitle } from '../step-title';
import { NumberedStep } from '../numbered-step';

export const EncoderSetupStep: React.FC = () => {
  return (
    <Flex
      direction="column"
      align="center"
      minH="100vh"
      px={6}
      pt={16}
      pb={24}
      bg="white"
      overflowY="auto"
    >
      <VStack gap={5} maxW="500px" w="full">
        <StepTitle
          stepNumber={4}
          title="Secure The Encoder To The Tripod & Confirm Internet Connection"
        />

        {/* Encoder Setup Instructions */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={2}>
            <NumberedStep number={1}>
              Screw the silver encoder mount into the tripod
            </NumberedStep>
            <NumberedStep number={2}>
              Continue to screw on the encoder until it is secured to the
              tripod. Ensure the encoder screen is bottom-left. If the encoder
              screen doesn't sit bottom-left when screwed onto the tripod, leave
              it slightly loose so it's correctly oriented, or rest it safely on
              the FrogBox backpack, the ground, chair, or a nearby table.
            </NumberedStep>
            <NumberedStep number={3}>
              Screw on the antennas (2) (for SIM or WiFi connections) or insert
              the Ethernet cable
            </NumberedStep>
            <NumberedStep number={4}>
              Check to make sure the encoder is on. If not, press the power
              button for 5 seconds
            </NumberedStep>
            <NumberedStep number={5}>
              Wait until the preview screen lights up. A network symbol should
              appear confirming successful internet connection. If it doesn't
              appear, click the following link for a guide on{' '}
              <Link
                href="https://frogbox.freshdesk.com/support/solutions/articles/51000510474-how-to-connect-your-kit-to-the-internet"
                color="green.600"
                fontWeight="semibold"
                textDecoration="underline"
                _hover={{ color: 'green.700' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                how to connect your kit to the internet
              </Link>
              .
            </NumberedStep>
          </VStack>
        </Box>

        {/* Diagram */}
        <Box w="full" borderRadius="xl" overflow="hidden">
          <img
            src={`${import.meta.env.BASE_URL}images/encoder-mounting.webp`}
            alt="Encoder mounting instructions"
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>
      </VStack>
    </Flex>
  );
};
